import React from 'react';
import { Box } from '@mui/material';
import StyledBox from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/components/ContentSection/ContentSection.styles';
import { Typography700 } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';

interface ContentSectionProps {
  description?: string;
}

const ContentSection: React.FC<ContentSectionProps> = (props) => {
  const { description } = props;
  const content = useContent('BlogDetailsPage');
  return (
    <StyledBox>
      <Box
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </StyledBox>
  );
};

export { ContentSection };
